
import { Component, Prop, Vue } from 'vue-property-decorator';
import NoteRepositoryInterface from '@/services/QA/note/interfaces';

@Component({
  inject: [
    'noteRepository',
  ],
})
export default class EditNoteDialog extends Vue {
  @Prop() private readonly noteId!: number;
  @Prop() private readonly content!: string;
  @Prop() private readonly notifyUsers!: boolean;
  private newContent: string = '';
  private noteRepository!: NoteRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return 'Content';
  }

  public created(): void {
    this.newContent = this.content;
  }

  private async editNote(): Promise<void> {
    try {
      await this.noteRepository.editNote(this.noteId, this.newContent, this.notifyUsers);

      this.$successDialog.show('Note Edited');
      this.$emit('noteEdited', this.noteId, this.newContent);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
